import React, { useContext, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaSearch, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../../../components/loader";
import buildLink from "../../../../urls";
import MessageAlert from "../../../../components/messageAlert";
import hocStarredPage from "../../../../components/hocStarredPage";
import { CompanyContext } from "../../../../contexts/companyCotext";
import { PlaySounds } from "../../../../functions/playSounds";
import Cookies from "js-cookie";
import { axiosServer } from "../../../../axiosServer";

const Restockv2 = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const history = useNavigate();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [returnInf, setReturnInf] = useState(null);
  const codePr = useRef(null);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [isMaster, setIsMaster] = useState(false);
  const [salves, setSlaves] = useState([]);
  const [selectedSlave, SetSelectedSlave] = useState();
  const [counter, setCounter] = useState(0);
  const commentRef = useRef(null);
  const addressRef = useRef(null);
  const skuSLave = useRef(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  var host = window.location.host;
  const [warehouseResInfo, setWarehouseRespInfo] = useState({
    address: "",
    name: "",
    address_id: "",
  });

  const searchReturn = async (e) => {
    setLoadingSearch(true);
    e.preventDefault();

    const item = codePr.current.value;

    try {
      const url =
        buildLink("returnOrderProduct") + `&return_order_product_id=${item}`;
      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          setReturnInf(response.data.data);
          if (response.data.data.is_master) {
            setIsMaster(response.data.data.is_master);
            setSlaves(response.data.data?.slaves);
          }
          setMessage(response.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);

          setWarehouseRespInfo((prev) => ({
            ...prev,
            name: response?.data?.data?.warehouse?.name,
            address: response?.data?.data?.warehouse?.address,
            address_id: response?.data?.data?.warehouse?.address_id,
          }));
        }
      });
      setLoadingSearch(false);
    } catch (e) {
      console.log(e);
      setLoadingSearch(false);
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      setWarehouseRespInfo({
        name: "",
        address: "",
        address_id: "",
      });
    }
    setLoadingSearch(false);
  };

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  async function reset() {
    const userID = getUserIdFromLocalStorage();
    const url = buildLink("updateReturnOrderProduct");
    const return_order_product_id = codePr.current.value;
    const return_status_id = 26;
    const user_id = userID;
    const comment = commentRef.current.value;
    const type = "undoRestock";
    const address_id = addressRef.current.value;
    const obj = {
      return_order_product_id,
      return_status_id,
      comment,
      type: type,
      user_id,
    };

    if (address_id) {
      obj["address_id"] = address_id;
    }

    try {
      await axiosServer.put(url, obj).then((res) => {
        if (res.data.success) {
          playSuccessSound();
          setMessage(res.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        }
      });
    } catch (e) {
      playErrorSound();
      setMessage("Return Order Product is empty!");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }

  const resetInputs = () => {
    if (codePr.current) {
      codePr.current.value = "";
    }
    if (skuSLave.current) {
      skuSLave.current.value = "";
    }

    if (commentRef.current) {
      commentRef.current.value = "";
    }

    if (addressRef.current) {
      addressRef.current.value = "";
    }

    setIsMaster(false);
    setSlaves([]);
    SetSelectedSlave(null);
    setCounter(0);
    setWarehouseRespInfo({
      address: "",
      name: "",
      address_id: "",
    });
  };

  async function handleSave() {
    const userID = getUserIdFromLocalStorage();
    const url = buildLink("updateReturnOrderProduct");
    const return_order_product_id = codePr.current.value;
    const return_status_id = 26;
    const user_id = userID;
    const comment = commentRef.current.value;
    const type = "";
    const address_id = addressRef.current.value;

    if (address_id && address_id !== warehouseResInfo.address_id) {
      setMessage("Address Id Not match");
      playErrorSound();
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    const obj = {
      return_order_product_id,
      return_status_id,
      comment,
      type: type,
      user_id,
    };

    if (isMaster && selectedSlave?.quantity === counter) {
      obj["product_id"] = selectedSlave?.product_id;
    }

    if (address_id) {
      obj["address_id"] = address_id;
    }

    try {
      await axiosServer.put(url, obj).then((res) => {
        if (res.data.success) {
          resetInputs();
          playSuccessSound();
          setMessage(res.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        } else {
          setMessage(res.data.message);
          playErrorSound();
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        }
      });
    } catch (e) {
      setMessage(e.response.data.message);
      playErrorSound();
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }

  useEffect(() => {
    codePr.current.focus();
  }, []);

  const handleChangeCounter = (event) => {
    if (event.key === "Enter") {
      const selectedSlaveSku = salves.find(
        (salve) => salve?.sku === event.target.value
      );
      if (!selectedSlaveSku) {
        skuSLave.current.value = "";
        setMessage("Incorrect Slave SKU");
        playErrorSound();
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }
      if (!selectedSlave) {
        skuSLave.current.value = "";
        SetSelectedSlave(selectedSlaveSku);
        setWarehouseRespInfo(selectedSlaveSku?.warehouse);
        setCounter(1);
      } else if (selectedSlave && counter < selectedSlave.quantity) {
        if (selectedSlave?.sku !== event.target.value) {
          setMessage(
            `SKU '${event.target.value}' exists but is NOT the originally selected slave SKU`
          );
          playErrorSound();
          setShowMessageErr(true);
          skuSLave.current.value = "";
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        } else {
          setCounter((prev) => prev + 1);
        }
      }
    }
  };

  const handleTrashClick = () => {
    codePr.current.value = "";
    codePr.current.focus();
  };

  return (
    <>
      <div className=" h-full  bg-white ">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Restock</h2>
            </div>
          </div>
        </div>

        <div className="container flex flex-col gap-5">
          <form onSubmit={(e) => searchReturn(e)}>
            <div className="mb-1">Rerturn Order Product ID</div>
            <div className=" flex flex-row justify-center gap-3 ">
              <div className="relative flex-1">
                <input
                  ref={codePr}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Rerturn Order Product"
                />
                <div>
                  <FaTrash
                    onClick={() => handleTrashClick()}
                    className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                  />
                </div>
              </div>
              <button className=" bg-dbase rounded-md text-white px-5 ">
                {" "}
                {loadingSearch ? <Loader /> : <FaSearch />}{" "}
              </button>
            </div>
          </form>

          {isMaster && (
            <div className="flex items-center gap-4">
              <div className="mb-1">Slave SKU</div>
              <div className="flex-1">
                <input
                  ref={skuSLave}
                  type="text"
                  onKeyDown={handleChangeCounter}
                  placeholder="Slave SKU"
                  className="w-full rounded-lg border border-dlabelColor px-3 py-3 text-dblack 
                            placeholder-dgrey1 focus:outline-none focus:ring-2 focus:ring-dblue 
                            transition-all"
                />
              </div>
              <button
                className="w-32 rounded-lg border border-dlabelColor bg-dplaceHolder 
                          py-3 text-center font-medium hover:bg-dlabelColor hover:text-white 
                          transition"
              >
                {counter}
              </button>
            </div>
          )}

          {/* <div className="relative flex-1">
                <input
                  ref={prodcutPlace}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Product Place"
                />
                <div onClick={() => (prodcutPlace.current.value = "")}>
                  <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
                </div>
              </div> */}
          <div className="relative flex-1">
            <div className="mb-1">Comment</div>
            <input
              ref={commentRef}
              type="text"
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Comment"
            />
            <div onClick={() => (commentRef.current.value = "")}>
              <FaTrash className="absolute top-[52px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
            </div>
          </div>
          <div className="relative flex-1">
            <div className="mb-1">Address</div>
            <input
              ref={addressRef}
              type="text"
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Address"
            />
            <div onClick={() => (addressRef.current.value = "")}>
              <FaTrash className="absolute top-[52px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
            </div>
          </div>

          <div className="w-full flex flex-row gap-3">
            {" "}
            <button
              onClick={handleSave}
              disabled={
                isMaster &&
                (!selectedSlave || counter < selectedSlave?.quantity)
              }
              className={`w-full py-2 text-white ${isMaster &&
                  (!selectedSlave || counter < selectedSlave?.quantity)
                  ? "bg-dgreySeller cursor-not-allowed"
                  : "bg-dbase"
                }`}
            >
              Save
            </button>{" "}
            <button
              onClick={() => reset()}
              className="w-44 py-2 border border-dbase text-dbase bg-white 
                rounded-md font-medium
                hover:bg-dbase hover:text-white hover:shadow-md
                transition-all duration-300 ease-in-out"
            >
              Reset
            </button>
          </div>

          {(warehouseResInfo.address || warehouseResInfo.name) && (
            <div className="mt-2 space-y-2 text-sm p-3 border rounded-md w-fit">
              {warehouseResInfo.name && (
                <div className="flex">
                  <span className="w-32 font-medium text-dgreyAccount">
                    Warehouse Name:
                  </span>
                  <span className="">{warehouseResInfo.name}</span>
                </div>
              )}
              {warehouseResInfo.address && (
                <div className="flex">
                  <span className="w-32 font-medium text-dgreyAccount">
                    Address:
                  </span>
                  <span className="">{warehouseResInfo.address}</span>
                </div>
              )}
            </div>
          )}
        </div>

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(Restockv2);
